/* eslint-disable no-unused-vars */
import { Scene, Input, Math as MathPhaser, Geom, Display } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, lightstickHandler, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import ButtonPressed from "../../phaser/components/buttonPressed";
import { addButtonMove } from "../../phaser/components/buttonMove";
import SettingsButton from "../../phaser/components/settingsButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;

let characterSelected;
let objNames = {};
let allCharacters = {};
let footsteps;
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;
let numberOfTouch = 0;
let instructionsHandler = 0;
let gameToShow;

let pointsToChangeGame = [
    { x: 0, y: 0 }
];


export default class Game14 extends Scene {

    constructor() {
        super({ key: "Game14" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        hasLightstick = false;
        this.firstStep = true;
        numberOfTouch = 0;
        this.events.off('buttonNext-dialogModal');
        this.startAll = false;
        setLastMovement('down');
        instructionsHandler = 0;
        gameToShow = 1;
    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();
            }
            this.isPause = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.isPause = false;
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                window.removeEventListener("blur", this.onBlurHandler);
                if (args.goHome) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true });
                }

                if (args.goStart) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }
                // if(this.isMobile) {
                //     this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game${gameToShow}`, 300);
                // }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 6224);
        this.physics.world.setBounds(0, 0, 6224);

        this.ppalSong = this.sound.add(`song`, { loop: false, volume: 0.2 });

        // if (gameSettings === '1') {
        //     this.ppalSong.play();
        // }

        

        this.map = mapHandler(this, 'game14', false, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(1.5);
        this.map.ground.setScale(1.5);


        this.door = this.map.map.createLayer('Door', this.map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(1.5);

        this.stage = this.map.map.createLayer('Stage', this.map.tileset, 0, 0);
        this.stage.setCollisionByProperty({ collides: true });
        this.stage.setScale(1.5);

        this.win = this.map.map.createLayer('Win', this.map.tileset, 0, 0);
        this.win.setCollisionByProperty({ collides: true });
        this.win.setScale(1.5);

        // this.lightstick = this.physics.add.sprite(1845, 2053, 'lightstick').setVisible(false).setActive(false).setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(43, 2086, `${characterSelected}-game1`, 4);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();
        // objNames[characterSelected].setBounce(1);

        this.add.graphics()
            .lineStyle(5, 0x00ffff, 0.5)

        walkAnimation(this, `${characterSelected}-game1`);
        reposeAnimation(this, `${characterSelected}-game1`);
        turnStaticAnimation(this, `${characterSelected}-game1`);
        upStaticAnimation(this, `${characterSelected}-game1`);
        leftStaticAnimation(this, `${characterSelected}-game1`);
        rightStaticAnimation(this, `${characterSelected}-game1`);
        backStaticAnimation(this, `${characterSelected}-game1`);
        lightstickAnimation(this, `${characterSelected}-game1`);
        walkAnimation(this, `${characterSelected}-game2`);
        reposeAnimation(this, `${characterSelected}-game2`);
        turnStaticAnimation(this, `${characterSelected}-game2`);
        upStaticAnimation(this, `${characterSelected}-game2`);
        leftStaticAnimation(this, `${characterSelected}-game2`);
        rightStaticAnimation(this, `${characterSelected}-game2`);
        backStaticAnimation(this, `${characterSelected}-game2`);
        lightstickAnimation(this, `${characterSelected}-game2`);
        walkAnimation(this, `${characterSelected}-game3`);
        reposeAnimation(this, `${characterSelected}-game3`);
        turnStaticAnimation(this, `${characterSelected}-game3`);
        upStaticAnimation(this, `${characterSelected}-game3`);
        leftStaticAnimation(this, `${characterSelected}-game3`);
        rightStaticAnimation(this, `${characterSelected}-game3`);
        backStaticAnimation(this, `${characterSelected}-game3`);
        lightstickAnimation(this, `${characterSelected}-game3`);
        walkAnimation(this, `${characterSelected}-game4`);
        reposeAnimation(this, `${characterSelected}-game4`);
        turnStaticAnimation(this, `${characterSelected}-game4`);
        upStaticAnimation(this, `${characterSelected}-game4`);
        leftStaticAnimation(this, `${characterSelected}-game4`);
        rightStaticAnimation(this, `${characterSelected}-game4`);
        backStaticAnimation(this, `${characterSelected}-game4`);
        lightstickAnimation(this, `${characterSelected}-game4`);
        walkAnimation(this, `${characterSelected}-game5`);
        reposeAnimation(this, `${characterSelected}-game5`);
        turnStaticAnimation(this, `${characterSelected}-game5`);
        upStaticAnimation(this, `${characterSelected}-game5`);
        leftStaticAnimation(this, `${characterSelected}-game5`);
        rightStaticAnimation(this, `${characterSelected}-game5`);
        backStaticAnimation(this, `${characterSelected}-game5`);
        lightstickAnimation(this, `${characterSelected}-game5`);
        walkAnimation(this, `${characterSelected}-game6`);
        reposeAnimation(this, `${characterSelected}-game6`);
        turnStaticAnimation(this, `${characterSelected}-game6`);
        upStaticAnimation(this, `${characterSelected}-game6`);
        leftStaticAnimation(this, `${characterSelected}-game6`);
        rightStaticAnimation(this, `${characterSelected}-game6`);
        backStaticAnimation(this, `${characterSelected}-game6`);
        lightstickAnimation(this, `${characterSelected}-game6`);
        walkAnimation(this, `${characterSelected}-game7`);
        reposeAnimation(this, `${characterSelected}-game7`);
        turnStaticAnimation(this, `${characterSelected}-game7`);
        upStaticAnimation(this, `${characterSelected}-game7`);
        leftStaticAnimation(this, `${characterSelected}-game7`);
        rightStaticAnimation(this, `${characterSelected}-game7`);
        backStaticAnimation(this, `${characterSelected}-game7`);
        lightstickAnimation(this, `${characterSelected}-game7`);
        walkAnimation(this, `${characterSelected}-game8`);
        reposeAnimation(this, `${characterSelected}-game8`);
        turnStaticAnimation(this, `${characterSelected}-game8`);
        upStaticAnimation(this, `${characterSelected}-game8`);
        leftStaticAnimation(this, `${characterSelected}-game8`);
        rightStaticAnimation(this, `${characterSelected}-game8`);
        backStaticAnimation(this, `${characterSelected}-game8`);
        lightstickAnimation(this, `${characterSelected}-game8`);
        walkAnimation(this, `${characterSelected}-game9`);
        reposeAnimation(this, `${characterSelected}-game9`);
        turnStaticAnimation(this, `${characterSelected}-game9`);
        upStaticAnimation(this, `${characterSelected}-game9`);
        leftStaticAnimation(this, `${characterSelected}-game9`);
        rightStaticAnimation(this, `${characterSelected}-game9`);
        backStaticAnimation(this, `${characterSelected}-game9`);
        lightstickAnimation(this, `${characterSelected}-game9`);
        walkAnimation(this, `${characterSelected}-game10`);
        reposeAnimation(this, `${characterSelected}-game10`);
        turnStaticAnimation(this, `${characterSelected}-game10`);
        upStaticAnimation(this, `${characterSelected}-game10`);
        leftStaticAnimation(this, `${characterSelected}-game10`);
        rightStaticAnimation(this, `${characterSelected}-game10`);
        backStaticAnimation(this, `${characterSelected}-game10`);
        lightstickAnimation(this, `${characterSelected}-game10`);
        walkAnimation(this, `${characterSelected}-game11`);
        reposeAnimation(this, `${characterSelected}-game11`);
        turnStaticAnimation(this, `${characterSelected}-game11`);
        upStaticAnimation(this, `${characterSelected}-game11`);
        leftStaticAnimation(this, `${characterSelected}-game11`);
        rightStaticAnimation(this, `${characterSelected}-game11`);
        backStaticAnimation(this, `${characterSelected}-game11`);
        lightstickAnimation(this, `${characterSelected}-game11`);
        walkAnimation(this, `${characterSelected}-game12`);
        reposeAnimation(this, `${characterSelected}-game12`);
        turnStaticAnimation(this, `${characterSelected}-game12`);
        upStaticAnimation(this, `${characterSelected}-game12`);
        leftStaticAnimation(this, `${characterSelected}-game12`);
        rightStaticAnimation(this, `${characterSelected}-game12`);
        backStaticAnimation(this, `${characterSelected}-game12`);
        lightstickAnimation(this, `${characterSelected}-game12`);

        // this.anims.create({
        //     key: `deadSpriteAnimation`,
        //     frames: this.anims.generateFrameNumbers('humo-game14', { start: 0, end: 16 }),
        //     frameRate: 7,
        //     repeat: -1
        // });

        this.ppalSong.on('complete', () => {
            this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            window.removeEventListener("blur", this.onBlurHandler);
                            this.events.off('buttonNext-dialogModal');
                            this.scene.start(`Credits`);
                        }
                    });
        });


        this.collidesWalls = this.physics.add.collider(objNames[characterSelected], walls);

        this.physics.add.collider(objNames[characterSelected], this.door, () => {
            if(!this.isOverStage) {
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    
                    if (progress === 1) {
                        this.isOverStage = true;
                        objNames[characterSelected].setTexture(`${characterSelected}-game12`);
                        this.cameras.main.fadeIn();

                        // objNames[characterSelected].setPosition((objNames[characterSelected].x  + 300), objNames[characterSelected].y);
                        objNames[characterSelected].setScale(1.5);
                        walls.setScale(1);
                        this.door.setScale(1);
                        objNames[characterSelected].setPosition((objNames[characterSelected].x + 300) / 1.5, objNames[characterSelected].y / 1.5);
    
                            
                        this.map.ground.setScale(1);
                        this.stage.setScale(1);
                        this.win.setScale(1);
                    }
                });

            }
        }, null, this);

        // this.physics.add.collider(objNames[characterSelected], this.object);
        // this.physics.add.collider(dobleEnemy, this.object);

        this.physics.add.overlap(objNames[characterSelected], this.stage, function onOverlap() {
            this.isOverStage = true;
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.physics.add.overlap(objNames[characterSelected], this.win, function onOverlap() {
            // this.physics.add.collider(objNames[characterSelected], this.win, () => {

            if(this.instructionMessage) {
                this.instructionMessage.visible = true;
            }
            if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                
                this.startAll = false;
                // this.dialogModal._createWindow(this, 'dialog-win', null, true);
                // this.dialogModal.setText("Great! I found the lightstick !".toUpperCase(), true, true);
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        objNames[characterSelected].active = false;
                        objNames[characterSelected].visible = false;
                        objNames[characterSelected].setPosition(2475, 500);
                        this.cameras.main.fadeIn();
                        // objNames[characterSelected].setPosition((objNames[characterSelected].x  + 300), objNames[characterSelected].y);
                        const members = ['jiu', 'sua', 'siyeon', 'handong', 'yoohyeon', 'dami', 'gahyeon'];
                        // const games = ['game1', 'game2', 'game2', 'game3', 'game4', 'game5', 'game6', 'game7', 'game8', 'game9', 'game10', 'game11', 'game12'];
                        let initX = 2255;
                        // let initY = 480;
                        // for(const [i, g] of games.entries()) {
                        //     if((i+1)%3 === 0) {
                        //         initY+=40
                        //         initX = 2120;
                        //     }
                            for(const m of members) {
                                    lightstickAnimation(this, `${m}-game12`);
                                allCharacters
                                initX+=60
                                allCharacters[m] = this.physics.add.sprite(initX, 500, `${m}-game12`, 4);
                                allCharacters[m].setScale(1.5);
                                allCharacters[m].setImmovable();

                                allCharacters[m].anims.play(`lightstick-${m}-game12`)

                        //     }
                        }
                        this.instructionMessage.setVisible(false);
                        this.instructionMessage = false;

                        if (gameSettings === '1') {
                            this.messageSong.visible = true;

                            this.ppalSong.play();
                        } else {
                            setTimeout(() => {
                                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                                    if (progress === 1) {
                                        footsteps.stop();
                                        this.ppalSong.stop();
                                        this.scene.stop();
                                        window.removeEventListener("blur", this.onBlurHandler);

                                        this.events.off('buttonNext-dialogModal');
            
                                        //TODO CREDITOS
                                        this.scene.start(`Credits`);
                                    }
                                });
                            }, 3000);
                        }
                        if(this.joystickManager) {
                            this.joystickManager.destroyTest();
                            this.joystickManager = null;
                        }
                        
                        // setTimeout(() => {
                        //     this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        //         if (progress === 1) {
                        //             footsteps.stop();
                        //             this.ppalSong.stop();
                        //             this.scene.stop();
                        //             this.events.off('buttonNext-dialogModal');
        
                        //             //TODO CREDITOS
                        //             this.scene.start(`Credits`);
                        //         }
                        //     });

                        // }, 10000);
                        // this.dialogModal._createImageDialog(this, 'dialog-win');
                        // this.dialogModal.setText("TEXTO FINAL !".toUpperCase(), `${characterSelected}-hallway`, false, false);
                    }

                });

            }

            clearTimeout(this.timeoutInstruction);


            this.timeoutInstruction = setTimeout(() => {
                this.instructionMessage.visible = false;
            }, 100);
        }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );
    // }, null, this);



        this.cameras.main.startFollow(objNames[characterSelected], true);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);

        this.onBlurHandler = () => {
            this.isPause = true;
            this.buttonPause.pauseByEvent();
        };

        window.addEventListener("blur", this.onBlurHandler);


        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         this.isPause = true;
        //         this.buttonPause.pauseByEvent();
        //     }
        // });

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game1`);
        this.dialogModal._createImageDialog(this, 'first-dialog');
        this.showingInstruction = true;
        // this.dialogModal._createWindow(this, 'first-dialog', null, true);
        this.dialogModal.setText(". . .".toUpperCase(), `${characterSelected}-hallway`, false, false)

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            let total = JSON.parse(localStorage.getItem('noL'));

            switch (data.id) {
                case 'first-dialog':
                    switch (instructionsHandler) {
                        case 1:

                            this.dialogModal.close();
                            this.startAll = true;
                            instructionsHandler = 0;
                            this.showingInstruction = false;

                            if(this.isMobile) {
                                this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game${gameToShow}`, 300);
                                this.joystickManager.createJoystick();
                                this.joystickManager.activate(hasLightstick);
                            }

                            break;
                    }
                    break;
                // case 'dialog-win':
                //     this.dialogModal.close();
                //     instructionsHandler = 0;
                //     // if (total) {
                //     //     if (!total.includes(10)) {
                //     //         total.push(10);
                //     //         localStorage.setItem('noL', JSON.stringify(total));

                //     //     }
                //     // } else {
                //     //     localStorage.setItem('noL', JSON.stringify([10]));
                //     // }

                //     this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                //         if (progress === 1) {
                //             footsteps.stop();
                //             this.ppalSong.stop();
                //             this.scene.stop();
                //             this.events.off('buttonNext-dialogModal');

                //             //TODO CREDITOS
                //             this.scene.start(`Credits`);
                //         }
                //     });
                //     break;
            }

        }, this);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        this.instructionMessage = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 120, 20, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        this.messageSong = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 120, this.cameras.main.height - 50, 
            'pixelfont', "Wait until the song is over.".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        // this.instructionMessage = this.add.image((this.cameras.main.worldView.x + this.cameras.main.width / 2), 30, `interact-dialog`).setOrigin(0.5).setScale(1.5).setVisible(false).setScrollFactor(0);

        // this.instructionMessage = this.add.image(0, 30, `interact-dialog`).setOrigin(0.5).setScale(1.5).setVisible(false).setScrollFactor(0);
        // this.instructionMessage = this.add.text((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 50, 16, 'INTERACT: SPACEBAR', { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setVisible(false).setOrigin(1, 0).setScrollFactor(0);


    }



    update() {

        // console.log("X", objNames[characterSelected].x);
        // console.log("Y", objNames[characterSelected].y);

        const x = objNames[characterSelected].x;
        const y = objNames[characterSelected].y;

        if (this.startAll) {
            if (this.isMobile) {
                if(this.joystickManager) {
                    this.joystickManager.characterSelected = `${characterSelected}-game${gameToShow}`;
                    this.joystickManager.show();
                }
            } else {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game${gameToShow}`, hasLightstick);
            }

            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

            if(!this.isOverStage) {

                if (x <= 180) {
                    gameToShow = 1;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 180 && x <= 360) {
                    gameToShow = 2;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 360 && x <= 540) {
                    gameToShow = 3;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 540 && x <= 720) {
                    gameToShow = 4;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 720 && x <= 900) {
                    gameToShow = 5;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 900 && x <= 1080) {
                    gameToShow = 6;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 1080 && x <= 1260) {
                    gameToShow = 7;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 1260 && x <= 1440) {
                    gameToShow = 8;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 1440 && x <= 1620) {
                    gameToShow = 9;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 1620 && x <= 1800) {
                    gameToShow = 10;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                if (x > 1800 && x <= 2278) {
                    gameToShow = 11;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                }
    
                
            } else {
                    gameToShow = 12;
                    this.countChange++;
                    if (this.countChange === 1) {
                        objNames[characterSelected].setTexture(`${characterSelected}-game${gameToShow}`);
                        this.countChange = 0;
                    }
                // }
            }



        } else {
            if(this.isMobile) {
                if(this.joystickManager) {

                    this.joystickManager.pause();
                }
            }
        }

        if (!this.isMobile && this.pauseButton.isDown) {
            this.isPause = true;
            this.scene.launch('Pause', { scene: 'Game14' });
            this.scene.pause();

        }

    }

    shutdown() {
    // Este evento de Phaser se dispara cuando la escena se para
    window.removeEventListener("blur", this.onBlurHandler);
}

destroy() {
    // Este evento de Phaser se dispara cuando la escena se elimina por completo
    window.removeEventListener("blur", this.onBlurHandler);
}

}